module.exports = __webpack_public_path__ + "static/media/garbageTruck_gray.313f1858.svg";